import { API_ROOT } from './.env'

export const buildUri = (params) => {
    let extension = '';
    if (params) {
        _.each(params, (value, key) => {
            if (value) {
                if (!extension) {
                    extension = '?';
                } else {
                    extension += '&';
                }
                extension += `${key}=${value}`;
            }
        });
    }
    return extension;
}

export const getOptions = (...args) => {
    let argString = args.join(',')
    return `${API_ROOT}options?fields=${argString}`
}

export const leadershipTypes = API_ROOT + 'leadership-types'

export const roleTypes = API_ROOT + 'role-types'

export const addressTypes = API_ROOT + 'address-types'

export const countries = API_ROOT + 'countries'

export const getPermission = (objectType = null, objectId = null) => {
    let params = (objectType && objectId) ? ('?object_type=' + objectType + '&object_id=' + objectId) : ''

    let url = API_ROOT + 'me/permissions' + params

    return url;
}


// WEBPACK FOOTER //
// ./src/api/index.js